import axios from 'axios'

const API_URL = process.env.VUE_APP_API_BASE_URL

class ReportService {
  getApplicableReportTypes () {
    return axios.get(API_URL + 'report/ApplicableReportTypes', { showLoader: false })
  }

  getDailyDepositeCashCheckReportList (reportDate) {
    return axios.get(API_URL + 'report/deposit-check-cash/' + reportDate, { showLoader: false })
  }

  getRefundReportList (reportDate) {
    return axios.get(API_URL + 'report/refund/' + reportDate, { showLoader: false })
  }

  getTaxReportList (fromDate, toDate) {
    return axios.get(API_URL + 'report/tax/' + fromDate + '/' + toDate, { showLoader: false })
  }

  // Class Reports start

  getClassSignupReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/class/signup/' + fromDate + '/' + toDate)
  }

  getClassEnrollmentReport (fromDate, toDate, classId, sectionId) {
    return axios.get(API_URL + 'report/class/enrollment/' + fromDate + '/' + toDate + '/' + classId + '/' + sectionId)
  }

  getClassSignupReportByClassId (ClassId, Year, SectionId) {
    return axios.get(API_URL + 'report/class/signup-by-class/' + ClassId + '/' + Year + '/' + SectionId)
  }

  getMedicalClassSignupReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/class/medical-signup/' + fromDate + '/' + toDate)
  }

  getClassAttendanceReport (sectionId) {
    return axios.get(API_URL + 'report/class/attendance/' + sectionId)
  }

  getTotalEnrolledAndWithdrawnReport (ClassId, sectionId, fromDate = 'null', toDate = 'null') {
    return axios.get(API_URL + 'report/class/enrollment-withdrawn-count/' + ClassId + '/' + sectionId + '/' + fromDate + '/' + toDate)
  }

  getClassObserverSignupReport (sectionId) {
    return axios.get(API_URL + 'report/class/observer-signup/' + sectionId)
  }

  getClassWaitingSignupReport (classId) {
    return axios.get(API_URL + 'report/class/waiting-list-signup/' + classId)
  }
  // Class Reports end

  // Product Reports start
  getAllProductsReport () {
    return axios.get(API_URL + 'report/products/all')
  }

  getProductNeedingReorderReport (showLoading = true) {
    return axios.get(API_URL + 'report/products/needing-reorder', { showLoader: showLoading })
  }

  getProductSoldReportBetweenDates (fromDate, toDate) {
    return axios.get(API_URL + 'report/products/sold/' + fromDate + '/' + toDate)
  }

  getProductNotSoldReportBetweenDates (fromDate, toDate) {
    return axios.get(API_URL + 'report/products/not-sold/' + fromDate + '/' + toDate)
  }

  getInventoryOrderingProductsReport () {
    return axios.get(API_URL + 'report/products/inventory-ordering')
  }
  // Product Reports end

  // Membership report start
  getMembershipReportBasedOnLastValidDate (lastValidDate) {
    return axios.get(API_URL + 'report/memberships/' + lastValidDate)
  }
  // Membership report end

  // Client report start
  getClientReportsBasedOnDueDateRange (fromDate, toDate) {
    return axios.get(API_URL + 'report/clients/search/' + fromDate + '/' + toDate)
  }

  getClientPaymentsReport () {
    return axios.get(API_URL + 'report/clients/payments')
  }

  getPercentageOfClientReport () {
    return axios.get(API_URL + 'report/clients/percentage')
  }

  getClassListForDeliveryHospitalClientReport () {
    return axios.get(API_URL + 'report/clients/delivery-hospital/class-list')
  }

  getClientsDeliveryHospitalReport (classId) {
    return axios.get(API_URL + 'report/clients/delivery-hospital/' + classId)
  }

  getStudentBirtDateReportByMonth (date, classId = 0, sectionId = 0) {
    return axios.get(API_URL + 'report/student/birth-day-report/' + date + '/' + classId + '/' + sectionId)
  }

  getIncompleteUserProfileReport () {
    return axios.get(API_URL + 'report/clients/incomplete-profile')
  }

  getDropoutStudentReport (fromdate, todate) {
    return axios.get(API_URL + 'report/student/dropout/' + fromdate + '/' + todate)
  }

  // Client report end

  // Rentals report start

  getRentalEquipmentStatusReport () {
    return axios.get(API_URL + 'report/rentals/equipment-status')
  }

  getRentalOverdueEquipmentStatusReport (showLoading = true) {
    return axios.get(API_URL + 'report/rentals/overdue-equipment-status', { showLoader: showLoading })
  }

  getRentalOccurancesReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/rentals/occurances/' + fromDate + '/' + toDate)
  }

  // Rental report end

  // Revenue report start

  getRevenueSubscriptionReport (startDate, endDate) {
    return axios.get(API_URL + 'report/revenue/subscriptions/' + startDate + '/' + endDate)
  }

  getInvoiceDueReport () {
    return axios.get(API_URL + 'report/revenue/invoice-due')
  }

  getRevenueFeesOwedReport () {
    return axios.get(API_URL + 'report/revenue/fees-owed')
  }

  getRevenueReceivedTaxReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/revenue/received-tax/' + fromDate + '/' + toDate)
  }

  getRevenueDepositReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/revenue/deposit-revenue/' + fromDate + '/' + toDate)
  }

  getRevenueDiscountReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/revenue/discount/' + fromDate + '/' + toDate)
  }

  getRevenueScholarshipReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/revenue/scholarship/' + fromDate + '/' + toDate)
  }

  getRevenueMediCalTransactionReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/revenue/medical-transaction/' + fromDate + '/' + toDate)
  }

  getRevenueCommercialTransactionReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/revenue/total-commercial-transaction/' + fromDate + '/' + toDate)
  }

  getRevenueDailyCashCheckReport (startDate, endDate = null) {
    return axios.get(API_URL + 'report/revenue/daily-deposite/' + startDate + (endDate ? '/' + endDate : ''))
  }

  getRevenueRefundReport (fromDate) {
    return axios.get(API_URL + 'report/revenue/refund/' + fromDate)
  }

  getRevenueMedicalByMonthReport (startDate, endDate) {
    return axios.get(API_URL + 'report/revenue/medical-by-month/' + startDate + '/' + endDate)
  }

  getProjectedSubscriptionRevenueReport (startDate, endDate) {
    return axios.get(API_URL + 'report/revenue/projected-subscription-revenue/' + startDate + '/' + endDate)
  }
  // Revenue report end

  // Revenue Breakdown start
  getRevenueBreakdownClassRevenueReport (fromDate, toDate, shopId) {
    return axios.get(API_URL + 'report/revenue-breakdown/class/' + fromDate + '/' + toDate + '/' + shopId)
  }

  getRevenueBreakdownProductRevenueReport (fromDate, toDate, shopId) {
    return axios.get(API_URL + 'report/revenue-breakdown/product/' + fromDate + '/' + toDate + '/' + shopId)
  }

  getRevenueBreakdownRentalRevenueReport (fromDate, toDate, shopId) {
    return axios.get(API_URL + 'report/revenue-breakdown/rental/' + fromDate + '/' + toDate + '/' + shopId)
  }

  getRevenueBreakdownSummaryByDaysReport (fromDate, toDate, shopId) {
    return axios.get(API_URL + 'report/revenue-breakdown/summary-days/' + fromDate + '/' + toDate + '/' + shopId)
  }

  getRevenueBreakdownSummaryByMonthsReport (fromDate, toDate, shopId) {
    return axios.get(API_URL + 'report/revenue-breakdown/summary-month/' + fromDate + '/' + toDate + '/' + shopId)
  }

  getRevenueBreakdownSummaryByYearReport (fromDate, toDate, shopId) {
    return axios.get(API_URL + 'report/revenue-breakdown/summary-year/' + fromDate + '/' + toDate + '/' + shopId)
  }
  // Revenue Breakdown end

  // Revenue Credits start
  getRevenueCreditRentalsReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/revenue-credit/rentals/' + fromDate + '/' + toDate + '/')
  }

  getRevenueCreditClientReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/revenue-credit/client/' + fromDate + '/' + toDate + '/')
  }

  getRevenueCreditClassReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/revenue-credit/class/' + fromDate + '/' + toDate + '/')
  }

  getRevenueCreditProductReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/revenue-credit/product/' + fromDate + '/' + toDate + '/')
  }

  getRevenueCreditDiscountReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/revenue-credit/discounts/' + fromDate + '/' + toDate + '/')
  }
  // Revenue Credits end

  // Moms mobile revenue report starts

  getMMRevenueSummaryReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/mom-mobile/revenue-summary/' + fromDate + '/' + toDate + '/')
  }

  getMMRevenueProductItemsReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/mom-mobile/revenue-product-items/' + fromDate + '/' + toDate + '/')
  }

  getMMRevenueRentalReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/mom-mobile/revenue-rental/' + fromDate + '/' + toDate + '/')
  }

  getMMRevenueOrderingReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/mom-mobile/revenue-ordering/' + fromDate + '/' + toDate + '/')
  }

  getMMRevenueClassReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/mom-mobile/revenue-class/' + fromDate + '/' + toDate + '/')
  }

  getMMRevenueMembershipReport (fromDate, toDate) {
    return axios.get(API_URL + 'report/mom-mobile/revenue-membership/' + fromDate + '/' + toDate + '/')
  }

  // Moms mobile revenue report ends

  // Support Group start
  getSupportGroupSignupReportbyDate (fromDate, toDate) {
    return axios.get(API_URL + 'report/supportgroup/signup-by-date/' + fromDate + '/' + toDate)
  }

  getSupportGroupSignupReportbySgId (supportGroupId) {
    return axios.get(API_URL + 'report/supportgroup/signup-report/' + supportGroupId)
  }

  getSupportGroupAttendanceReport (sessionId) {
    return axios.get(API_URL + 'report/supportgroup/attendance-report/' + sessionId)
  }
  // Support Group end

  // Tour start
  getTourSignupReportbyDate (fromDate, toDate) {
    return axios.get(API_URL + 'report/tour/tour-details-by-date/' + fromDate + '/' + toDate)
  }

  getTourAttendanceReport (tourId) {
    return axios.get(API_URL + 'report/tour/enrollment-details-by-tourid/' + tourId)
  }

  // Tour end
  // Parent Contact start

  getParentContactReport (classId, sectionId) {
    return axios.get(API_URL + 'report/class/parent-contact/' + classId + '/' + sectionId)
  }
  // Parent Contact end

  // Parent student Info start
  getParentStudentInfoReport (classId, sectionId) {
    return axios.get(API_URL + 'report/parent/section-wise-parent-student-info/' + classId + '/' + sectionId)
  }
  // Parent student Info end

  // Student Info start
  getStudentProfileReport (classId, sectionId) {
    return axios.get(API_URL + 'report/student/profile/' + classId + '/' + sectionId)
  }
  // Student Info end
}

export default new ReportService()
